const MOVE_FLOATING_PANEL = 'bitbyte-gui/floatingPanels/MOVE_FLOATING_PANEL';

const initialState = {
    code: {
        x: 16,
        y: 16,
        width: 720,
        height: 688
    },
    stage: {
        x: 752,
        y: 16,
        width: 480,
        height: 466
    },
    sprites: {
        x: 752,
        y: 498,
        width: 480,
        height: 320
    }
};

const RESIZE_FLOATING_PANEL = 'bitbyte-gui/floatingPanels/RESIZE_FLOATING_PANEL';
const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case MOVE_FLOATING_PANEL:
        return Object.assign({}, state, {
            [action.panelId]: {
                ...state[action.panelId],
                x: action.x,
                y: action.y
            }
        });
    case RESIZE_FLOATING_PANEL:
        return Object.assign({}, state, {
            [action.panelId]: {
                ...state[action.panelId],
                width: action.width,
                height: action.height
            }
        });
    default:
        return state;
    }
};

const moveFloatingPanel = function (panelId, x, y) {
    return {
        type: MOVE_FLOATING_PANEL,
        panelId,
        x,
        y
    };
};

const resizeFloatingPanel = function (panelId, width, height) {
    return {
        type: RESIZE_FLOATING_PANEL,
        panelId,
        width,
        height
    };
};

export {
    reducer as default,
    initialState as floatingPanelsInitialState,
    moveFloatingPanel,
    resizeFloatingPanel
};
